<div mat-dialog-content>
    <p>Please select parameter type</p>
    <mat-select [(ngModel)]="type" (selectionChange)="submit()" placeholder="Please select a type">
      <mat-option [value]="'static'">Static</mat-option>
      <mat-option [value]="'dynamic'">Dynamic</mat-option>
      <mat-option [value]="'third-party'">Third party</mat-option>
    </mat-select>
  </div>